import React, { useState, useEffect } from 'react';
import { ArrowUpIcon } from './Icons.tsx';

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <button
        type="button"
        onClick={scrollToTop}
        className={`bg-black hover:bg-gray-800 text-white dark:bg-[#FF4D00] dark:hover:bg-white dark:text-black rounded-full p-3 shadow-lg shadow-orange-600/30 dark:shadow-lg dark:shadow-[#FF4D00]/30 transition-all duration-300 transform ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'
        }`}
        aria-label="Go to top"
      >
        <ArrowUpIcon className="h-6 w-6" />
      </button>
    </div>
  );
};

export default BackToTop;